<template>
  <label class="d-flex justify-content-between">
    <template v-if="!!label">
      <span v-if="required" class="required">{{ label }}</span>
      <template v-else> {{ label }} </template>
    </template>

    <slot></slot>
  </label>
</template>

<script>
  export default {
    name: 'FormLabel',

    props: {
      label: String,
      required: Boolean,
    },
  };
</script>

<style lang="scss" scoped>
  .required::after {
    content: ' *';
    color: var(--primary);
  }
</style>
